import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CarrierModal from "../CarrierModal";

const EditAccountDialog = ({ row, onSave, onClose }) => {
  const { t } = useTranslation("settings");
  const [value, setValue] = useState(row.account_name ?? "");
  const [saving, setSaving] = useState(false);
  const empty = !value.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (empty) return;
    setSaving(true);
    // Sent as typed, like develop; the backend trims it.
    const saved = await onSave(row, value);
    setSaving(false);
    if (saved) onClose();
  };

  return (
    <CarrierModal
      onClose={saving ? undefined : onClose}
      boxClassName="!w-[440px] max-w-[94%] !rounded-[14px] !p-0 shadow-ui-md"
    >
      <form onSubmit={handleSubmit}>
        <div className="border-b border-ui-border px-[16px] py-[18px] text-[17px] font-semibold text-ui-text sm:px-[22px]">
          {t("carriers.edit.title")}
        </div>
        <label className="flex flex-col items-stretch gap-1 px-[16px] py-[18px] text-left text-xs font-medium text-state-neutral-text sm:px-[22px]">
          {t("carriers.columns.accountName")}
          <input
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
            className="h-10 rounded-lg border border-ui-border bg-ui-surface px-3 text-[13px] text-ui-text outline-none focus:border-brand focus:shadow-[0_0_0_2px_var(--color-brand)]"
          />
        </label>
        <div className="flex justify-end gap-2 border-t border-ui-border px-[16px] py-3.5 sm:px-[22px]">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="h-[38px] rounded-lg border border-ui-border bg-ui-surface px-4 text-[13px] text-ui-text-secondary"
          >
            {t("common:actions.cancel")}
          </button>
          <button
            type="submit"
            disabled={empty || saving}
            className="h-[38px] rounded-lg bg-brand px-[18px] text-[13px] font-medium text-brand-contrast hover:bg-brand-hover disabled:cursor-not-allowed disabled:opacity-60"
          >
            {saving ? t("carriers.saving") : t("common:actions.save")}
          </button>
        </div>
      </form>
    </CarrierModal>
  );
};

export default EditAccountDialog;
